import React, { type ComponentType } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import styles from './CreateRecordsModal.module.css';

interface Item {
  id: string;
  text: string;
}

type OnItemChange = (i: Item, v: string) => void;

interface EditableElementProps {
  item: Item;
  onChange: OnItemChange;
}

const EditableElement = ({ item, onChange }: EditableElementProps) => {
  return (
    <div className={styles.editableElement}>
      <input
        type='text'
        value={item.text || ''}
        onChange={e => onChange(item, e.target.value)}
      />
    </div>
  );
};

interface EditableListProps {
  items: Item[];
  onItemChange: OnItemChange;
}

const EditableList = ({ items, onItemChange }: EditableListProps) => {
  return (
    <div className={styles.editableList}>
      {items.map(item => (
        <EditableElement key={item.id} item={item} onChange={onItemChange} />
      ))}
    </div>
  );
};

export default ApplicationView<ComponentType<EditableListProps>>(EditableList);
